<app-header *ngIf="showHeader"></app-header> <router-outlet></router-outlet>
